import React from 'react';
import { AGREEXA_COMMISSION } from '../../types';
interface SplitPreviewProps {
  amount: number;
  currency: string;
  mode?: 'compact' | 'full';
}
export function SplitPreview({
  amount,
  currency,
  mode = 'full'
}: SplitPreviewProps) {
  const commission = amount * AGREEXA_COMMISSION;
  const net = amount - commission;
  const format = (val: number) => new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency
  }).format(val);
  if (mode === 'compact') {
    return <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-3 flex items-center justify-between" data-id="element-62">
        <div data-id="element-63">
          <p className="text-xs text-blue-600 font-medium" data-id="element-64">
            Cobro directo a tu cuenta MP
          </p>
          <p className="text-sm font-bold text-gray-900" data-id="element-65">{format(net)}</p>
        </div>
        <div className="text-right" data-id="element-66">
          <p className="text-xs text-gray-400" data-id="element-67">
            Comisión automática Agreexa ({AGREEXA_COMMISSION * 100}%)
          </p>
          <p className="text-xs font-medium text-gray-500" data-id="element-68">
            -{format(commission)}
          </p>
        </div>
      </div>;
  }
  return <div className="bg-gray-50 rounded-xl p-4 space-y-2" data-id="element-69">
      <div className="flex justify-between text-sm" data-id="element-70">
        <span className="text-gray-500" data-id="element-71">Monto del acuerdo</span>
        <span className="font-medium text-gray-900" data-id="element-72">{format(amount)}</span>
      </div>
      <div className="flex justify-between text-sm" data-id="element-73">
        <span className="text-gray-500" data-id="element-74">
          Comisión automática Agreexa ({AGREEXA_COMMISSION * 100}%)
        </span>
        <span className="text-red-500" data-id="element-75">-{format(commission)}</span>
      </div>
      <div className="pt-2 border-t border-gray-200 flex justify-between" data-id="element-76">
        <span className="font-medium text-gray-900" data-id="element-77">
          Cobro directo a tu cuenta MP
        </span>
        <span className="font-bold text-gray-900" data-id="element-78">{format(net)}</span>
      </div>
    </div>;
}